import React from 'react';
import { useSelector } from 'react-redux';
import * as S from './style';

export default function CardDadosProfissionais({ dadosInputs }) {
  const inputSelectOptionsAreaAtuacao = useSelector(state => state.inputs.inputSelectOptionsAreaAtuacao);
  const inputSelectOptionsInstituicao = useSelector(state => state.inputs.inputSelectOptionsInstituicao);

  return (
    <S.CardInputs className="boxShadow">
      <S.CardInputsTitulo>Dados Profissionais</S.CardInputsTitulo>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Cargo do Representante:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.cargoRepresentante}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Razão Social:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.razaoSocial}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>CNPJ:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.cnpj}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Inscrição Estadual:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.inscricaoEstadual}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Inscrição Municipal:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.inscricaoMunicipal}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Tipo de Instituição:</S.CardInputsLabel>
        <S.CardInputsDescricao>
          {inputSelectOptionsAreaAtuacao?.find(x => x.id === dadosInputs?.escolaridadeId)?.atuacao}
        </S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Área de Atuação:</S.CardInputsLabel>
        <S.CardInputsDescricao>
          {inputSelectOptionsInstituicao?.find(x => x.id === dadosInputs?.areaAtuacaoId)?.nomeInstituicao}
        </S.CardInputsDescricao>
      </S.CardInputsContainerLabel>
    </S.CardInputs>
  );
}
